export default {
  pageHeroV1: {
    container: {
      height: '90vh',
      width: '100%',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      pt: '100px'
    },

    content: {
      flexDirection: 'column',
      color: 'white',
      textAlign: 'center',
      mt: '100px',
      h1: {
        fontSize: ['2.5rem', '', '4.5rem'],
        marginBottom: 1,
        letterSpacing: '3px',
        borderColor: 'secondary',
        // backgroundColor: 'rgba(0,0,0,0.35)',
        padding: '1rem',
        fontFamily: 'heading',
        fontWeight: 'bolder',
        color: 'light',
        textTransform: 'uppercase'
      },
      h2: {
        marginBottom: 4
      }
    }
  }
}
